import { atom } from 'jotai';
import { TComment } from 'shared/models';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export interface IArticleCommentDetail {
  replies: TComment[];
  hasMore: boolean;
  cursor: number;
}

type TArticleCommentDetailStore = { [key: string]: IArticleCommentDetail | undefined };

const $ArticleCommentDetailStore = atom<TArticleCommentDetailStore>({});

export const $ArticleCommentDetail = safeAtomFamily((commentId: string) => {
  const a = atom(
    (get) => {
      return (
        get($ArticleCommentDetailStore)[commentId] || {
          replies: [],
          hasMore: true,
          cursor: 0,
        }
      );
    },
    (get, set, input: IArticleCommentDetail) => {
      const old = get($ArticleCommentDetailStore);

      set($ArticleCommentDetailStore, {
        ...old,
        [commentId]: input,
      });
    },
  );

  a.debugLabel = `$ArticleCommentDetail+${encodeURIComponent(commentId)}`;

  return a;
});
